module.exports = {
  defaultHome: '/home',
  deleteThisPages: [],
  locales: ['de', 'en'],
  defaultLocale: 'de'
}
